<template>
  <div :class="[{
    'group-left': groupId !== undefined,
    'group-col-2': config.answerConfig.optLayout === '02',
    'group-col-3': config.answerConfig.optLayout === '03'
    }]">
    <el-row :gutter="10">
      <el-col v-for="option in ((model.invalidConfig && model.invalidConfig.optionList) ? model.invalidConfig.optionList : config.optionList)" :key="option.id" :span="config.answerConfig.optLayout === '02' ? 12 : (config.answerConfig.optLayout === '03' ? 8 : 24)">
        <div
          v-if="isOther ? (option.optionGroupId === 99999 && option.visibility) : (groupId === undefined || (groupId !== undefined && groupId === option.optionGroupId)) && option.visibility"
          :key="option.id"
          class="option-item"
          @click="selectItem(option)"
        >
          <template v-if="multiple">
            <el-checkbox v-if="show" :value="isSelected(option)" :disabled="option.disabled ? true : false">
              <answer-lang :text="option.displayTitle"></answer-lang>
            </el-checkbox>
          </template>
          <template v-else>
            <el-radio :value="isSelected(option)" :label="true" :disabled="option.disabled ? true : false">
              <answer-lang :text="option.displayTitle"></answer-lang>
            </el-radio>
            <el-row v-if="config.answerConfig.isShowVotingScore === '1'" class="progress-bar-container">
              <el-progress :stroke-width="7" :text-inside="true" :percentage="option.percentage" :format="format" :color="progressColor"></el-progress>
              <div class="bottom">
                <div class="item left-item">
                  {{option.votes}}{{cvtLang('tipsVote', config.tipsVote)}}
                </div>
                <div class="item right-item">
                  {{option.rate}}%
                </div>
              </div>
            </el-row>
          </template>
          <template v-if="option.type !== 'other'">
            <div v-if="option.imgUrl" class="medio-main">
              <ipsos-av v-if="isAv(option.imgUrl)" :src="option.imgUrl"></ipsos-av>
              <ipsos-image v-else :imgUrl="option.imgUrl" :preview="option.id"></ipsos-image>
            </div>
          </template>
          <template v-else>
            <div v-if="option.imgUrl" class="medio-main">
              <ipsos-av v-if="isAv(option.imgUrl)" :src="option.imgUrl"></ipsos-av>
              <ipsos-image v-else :imgUrl="option.imgUrl" :preview="option.id"></ipsos-image>
            </div>
            <div @click.stop>
              <Input
                v-show="isSelected(option)"
                class="textarea"
                v-model="option.otherValue"
                type="textarea"
                :autosize="{minRows: 5,maxRows: 5}"
                :maxlength="200"
                style="margin-top:10px;"
              />
            </div>
          </template>
        </div>
      </el-col>
    </el-row>
  </div>
</template>

<script>
export default {
  name: 'AnswerOptionSinglePc',
  props: [
    'config',
    'model',
    'optionValueKey',
    'multiple',
    'groupId',
    'isOther',
    'cvtLang'
  ],
  data () {
    return {
      show: true,
      timer: null,
      progressColor: '#38ADAB',
    }
  },
  watch: {
    'model.invalidConfig.type' (newVal) {
      if (newVal) {
        // reset value
        this.model.invalidConfig.optionIds.forEach(id => {
          const optionItem = this.model.invalidConfig.optionList.find(item => item.optionName === id)
          if (optionItem) {
            this.$set(optionItem, 'disabled', 1)
          }
          this.model.value = ''
        })
      } else {
        if (this.model.invalidConfig) {
          this.model.invalidConfig.optionList.forEach(item => {
            item.disabled = 0
          })
        }
      }
    }
  },
  computed: {
  },
  methods: {
    isAv (url) {
      return url && url.includes('.mp4')
    },
    selectItem (option) {
      if (option.disabled) {return}
      sessionStorage.setItem('allOrderByIdStash', this.config.allOrderById)
      if (this.timer) {
        clearTimeout(this.timer)
        this.timer = null
      }
      this.timer = setTimeout(() => {
        this.show = false
        this.$nextTick(() => {
          this.show = true
        })
        this.$emit('selectItem', option)
      })
    },
    isSelected (option) {
      const { multiple, model } = this
      const { selectedValue, value } = this.getValue(option)
      if (multiple) {
        return value.includes(selectedValue)
      }
      return model.value === selectedValue
    },
    getValue (option) {
      const { model, optionValueKey } = this
      const selectedValue = option[optionValueKey]
      const value = model.value
      return {
        selectedValue,
        value
      }
    },
    format(){
      return '';
    }
  },
  created () {
  },
  mounted () {
  }
}
</script>
<style lang="scss" scoped>
.group-left {
  margin-left: 20px;
}
.group-col-2, .group-col-3 {
  margin-left: 0px;
}
.option-item {
  margin-bottom: 15px;
  >>> .el-radio {
    white-space: break-spaces;
    display: flex;
    line-height: 24px;
    .el-radio__input {
      padding-top: 10px;
    }
    .el-radio__inner {
      position: relative;
      top: -4px;
    }
  }
  .medio-main {
    .av-wrap {
      width: 100% !important;
    }
    >>> .video-js {
      width: 100% !important;
      height: 250px !important;
    }
  }
}

>>> .el-checkbox__label {
  display: inline-grid;
  white-space: pre-line;
  word-wrap: break-word;
  overflow: hidden;
}

.answer-pc {
  .medio-main {
    img {
      max-width: 100%;
    }
  }
}

.progress-bar-container {
  .bottom {
    display: flex;
    justify-content: space-between;
    .item {
      font-size: 12px;
      line-height: 22px;
    }
    .left-item {
      color: #808695;
    }
    .right-item {
      color: #26BFAD;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/answer/AnswerOptionSinglePc.vue